import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TraineeshipSupportTable = ({ data, accidentInsurance, size }) => {
    const { t } = useTranslation();

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>No financial support data available</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    {/* Financial Support Section */}
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                          The Receiving Organisation will provide financial support:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_c_fin_sup ? 'Yes' : 'No'}</Col>
                    </Row>
                    {data?.field_tr_pre_tbl_c_fin_sup && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                              Financial Support Value:
                            </Col>
                            <Col>{data?.field_tr_pre_tbl_c_fin_sup_value || ''}</Col>
                        </Row>
                    )}

                    {/* Contribution in Kind Section */}
                    <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={12}></Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                          The Receiving Organisation will provide a contribution in kind:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_c_contribution ? 'Yes' : 'No'}</Col>
                    </Row>
                    {data?.field_tr_pre_tbl_c_contribution && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                Contribution Value:
                            </Col>
                            <Col>{data?.field_tr_pre_tbl_c_contr_value || ''}</Col>
                        </Row>
                    )}

                    {/* Accident Insurance Section */}
                    {accidentInsurance && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}>
                                    <strong>Accident Insurance Coverage</strong>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Accident Insurance:
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins ? 'Yes' : 'No'}</Col>
                            </Row>
                            {accidentInsurance?.field_acc_ins && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Coverage on the Way:
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_way ? 'Yes' : 'No'}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            Coverage During Travel:
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_travel ? 'Yes' : 'No'}</Col>
                                    </Row>
                                </>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    Liability Insurance:
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins_liability ? 'Yes' : 'No'}</Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default TraineeshipSupportTable;